import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=596cc8a6&scoped=true&"
import script from "./ProductCreate.vue?vue&type=script&lang=js&"
export * from "./ProductCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreate.vue?vue&type=style&index=0&id=596cc8a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596cc8a6",
  null
  
)

export default component.exports